import { render, staticRenderFns } from "./PayUPopup.vue?vue&type=template&id=c2913b96&scoped=true&"
import script from "./PayUPopup.vue?vue&type=script&lang=js&"
export * from "./PayUPopup.vue?vue&type=script&lang=js&"
import style0 from "./PayUPopup.vue?vue&type=style&index=0&id=c2913b96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2913b96",
  null
  
)

export default component.exports